import { render, staticRenderFns } from "./select-inside.vue?vue&type=template&id=1a4fc79a"
import script from "./select-inside.vue?vue&type=script&lang=js"
export * from "./select-inside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports